<style scoped="scoped" lang="scss"></style>

<template>
  <div style="display: inline;">
    <!-- table表格 -->
    <yi_curd_table v-bind="$attrs" :name="$options.name" ref="yt" getUrl="/web/mrp/detail/page" getKey="rows" :columns="columns">
      <!-- 搜索框插槽 -->
      <template #conditions>
        <el-form size="mini" :inline="true" :model="yt.conditions" class="demo-form-inline">
          <el-form-item class="noborder" :label="$t('MRPdanhao')">
            <el-input disabled v-model="$attrs.mrpOrder.no"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('jihuadanhao')">
            <el-input disabled v-model="$attrs.mrpOrder.planNo"></el-input>
          </el-form-item>
          <el-form-item class="noborder" :label="$t('chanpinmingcheng')">
            <yi_cross_select disabled multiple :component="'web_base_matter_list'" :ids.sync="$attrs.mrpOrder.materialId"> </yi_cross_select>
          </el-form-item>
          <el-form-item :label="$t('MRPzhuangtai')">
            {{ mpOrderStatus }}
          </el-form-item>
          <el-form-item>
            <yi_curd_expand_button></yi_curd_expand_button>
          </el-form-item>
        </el-form>
      </template>
      <!-- 右侧按钮插槽 -->
      <template #buttonsR>
        <el-button size="mini" icon="yicon yicon-config_column" :title="$t('peizhilie')" @click="yt.showColumnsDialog()"></el-button>
      </template>
      <!-- 自定义某个字段 -->
      <template #MESsanweibianma="scope">
        <template>
          <span>{{ scope.row.mesUnit }}/{{ $t(store.state.dictJsonAll['UNIT_CONVERSION_TYPE'][scope.row.mesUnit]) }}</span>
        </template>
      </template>
      <template #WMSdanweibianma="scope">
        <template>
          <span>{{ scope.row.wmsUnit }}/{{ $t(store.state.dictJsonAll['UNIT_CONVERSION_TYPE'][scope.row.wmsUnit]) }}</span>
        </template>
      </template>
      <!-- 操作插槽 -->
      <template #caozuo="scope">
        <el-row :gutter="10">
          <el-col :span="0.1" v-if="scope.row.status == 1 || scope.row.inOrder == null">
            <el-button v-if="utils.checkPower('web_wms_mrp_order_detail_createInOrder')" :loading="createInOrderLoading" type="text" @click="createInOrder(scope.row)">{{ $t('xiafarukudan') }} </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.status == 1 || scope.row.outOrder == null">
            <el-button v-if="utils.checkPower('web_wms_mrp_order_detail_createOutOrder')" :loading="createOutOrderLoading" type="text" @click="createOutOrder(scope.row)">{{ $t('xiafachukudan') }} </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.status == 1">
            <el-button v-burylog="{ functionType: '用户行为', logType: '按钮点击', startData: {'s1': 'MRP明细-下发采购申请'} }" :loading="issuedPurchaseRequisitionLoading" v-if="utils.checkPower('web_wms_mrp_issued_purchase_requisition')" type="text" @click="issuedPurchaseRequisition(scope.row)">{{ $t('xiafacaigoushenqing') }} </el-button>
          </el-col>
          <el-col :span="0.1" v-if="scope.row.status == 1">
            <el-button v-if="utils.checkPower('web_wms_mrp_order_detail_shortageCalc')" type="text" @click="shortage(scope.row)">{{ $t('queliaojisuan') }} </el-button>
          </el-col>
        </el-row>
      </template>
    </yi_curd_table>

    <!-- 弹框 -->
    <el-dialog :show-close="true" :title="$t(yt.editObj.action)" :visible.sync="yt.isShowEditDialog" :width="yt.dialogWidth" :close-on-click-modal="false" append-to-body="append-to-body">
      <!--缺料计算-->
      <template v-if="yt.editObj.action == 'queliaojisuan'">
        <div class="dialog-scroller">
          <shortage_calculation ref="calculationOrder" :calculation="yt.editObj"></shortage_calculation>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button size="mini" @click="yt.isShowEditDialog = false">{{ $t('quxiao') }}</el-button>
          <el-button size="mini" :loading="yt.editObj.loading" @click="saveCalculation" type="primary">
            {{ $t('baocun') }}
          </el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>
<script type="text/javascript">
import shortage_calculation from './shortage_calculation.vue';
export default {
  name: 'web_wms_mrp_order_mrp_details_index',
  components: {
    shortage_calculation
  },
  data() {
    return {
      createInOrderLoading: false,
      createOutOrderLoading: false,
      issuedPurchaseRequisitionLoading: false,
      calculationId: null,
      dictionaryList: [],
      list: [],
      columns: [
        {
          label: 'wuliaobianma',
          prop: 'material.code',
          width: 130
        },
        {
          label: 'wuliaomingcheng',
          prop: 'material.name',
          width: 150
        },
        {
          label: 'MESsanweibianma',
          prop: 'mesUnit',
          type: 'slot',
          width: 150
        },
        {
          label: 'WMSdanweibianma',
          prop: 'wmsUnit',
          type: 'slot',
          width: 150
        },
        {
          label: 'xuqiushuliang',
          prop: 'demandQuantity'
        },
        {
          label: 'kucunshuliang',
          prop: 'inventoryQuantity',
          width: 150
        },
        {
          label: 'queliaoshuliang',
          prop: 'shortageQuantity',
          width: 150
        },
        {
          label: 'mingxizhuangtai',
          prop: 'status',
          type: 'dictionary',
          key: 'MRP_DETAIL_STATUS',
          width: 150
        },
        {
          label: 'xiafarukudanhao',
          prop: 'inOrder.no',
          width: 150
        },
        {
          label: 'xiafachukudanhao',
          prop: 'outOrder.no',
          width: 150
        },
        {
          label: 'beizhu',
          prop: 'remark',
          width: 150
        },
        {
          label: 'chuangjianshijian',
          prop: 'createTime',
          type: 'time'
        },
        {
          label: 'caozuo',
          type: 'slot',
          width: 250,
          fixed: 'right'
        }
      ]
    };
  },
  computed: {
    mpOrderStatus() {
      // 0-待计算、1-缺料、2-库存充足。
      console.log('this.$yt.list11', this.yt.list);
      if (this.yt.list.length == 0) {
        return this.$t(this.store.state.dictJsonAll['MRP_HEAD_STATUS'][0]);
      }
      console.log('this.$yt.list11', this.yt.list);
      if (this.yt.list.every(item => item.status === '2')) {
        //判断数组中每一条数据的status是否都等于2
        const status = 2;
        return this.$t(this.store.state.dictJsonAll['MRP_HEAD_STATUS'][status]);
      } else if (this.yt.list.some(item => item.status === '1')) {
        //判断数组中是否有一条数据的status是1
        const status = 1;
        return this.$t(this.store.state.dictJsonAll['MRP_HEAD_STATUS'][status]);
      } else {
        const status = 0;
        return this.$t(this.store.state.dictJsonAll['MRP_HEAD_STATUS'][status]);
      }
    }
  },
  created() {
    setTimeout(() => {
      this.yt.conditions = {
        mrpId: this.$attrs.mrpOrder.id
      };
      this.yt.get(1);
    }, 300);
  },

  methods: {
    shortage(row) {
      this.yt.showEditDialog('queliaojisuan', row, '80%');
      this.calculationId = row.id;
    },
    //下发采购申请
    issuedPurchaseRequisition(row) {
      this.issuedPurchaseRequisitionLoading = true;
      this.http
            .post('/custom/szkaisu/mrp/detail/issuedPurchaseRequisition', row)
            .then(res => {
              this.utils.successMessage(this.$t(res.msg));
              this.yt.get();
            })
            .catch(error => {
              this.utils.errorMessage(this.$t(error));
            }).finally(() => {        
              this.issuedPurchaseRequisitionLoading = false;
            });
    },
    // 缺料计算
    saveCalculation() {
      let ids = this.$refs['calculationOrder'].ids;
      if (ids !== null) {
        let params = {
          warehouseIds: ids,
          id: this.calculationId
        };
        return this.http
          .post('/web/mrp/detail/shortageCalc', params)
          .then(response => {
            this.utils.successMessage(this.$t(response.msg));
            this.yt.isShowEditDialog = false;
            this.yt.get();
          })
          .catch(error => {
            this.$message.error(error);
          });
      } else {
        this.$message.error(this.$t('qinggouxuanshuju'));
      }
    },
    // 下发入库
    createInOrder(row) {
      this.createInOrderLoading = true;
      let params = {
        id: row.id
      };
      this.http
        .post('/web/mrp/detail/createInOrder', params)
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get();
          this.createInOrderLoading = false;
        })
        .catch(error => {
          this.utils.errorMessage(this.$t(error));
          this.createInOrderLoading = false;
        });
    },
    // 下发出库
    createOutOrder(row) {
      this.createOutOrderLoading = true;
      let params = {
        id: row.id
      };
      this.http
        .post('/web/mrp/detail/createOutOrder', params)
        .then(res => {
          this.utils.successMessage(this.$t(res.msg));
          this.yt.get();
          this.createOutOrderLoading = false;
        })
        .catch(error => {
          this.utils.errorMessage(this.$t(error));
          this.createOutOrderLoading = false;
        });
    }
  }
};
</script>
